const PRIMARY_DOMAIN = "nutrimartrd.com";
const LEGACY_DOMAINS = new Set([
  "www.nutrimartrd.com",
  "nutrimarket.shop",
  "www.nutrimarket.shop",
]);

export function isLegacyPublicDomain(hostname: string): boolean {
  return LEGACY_DOMAINS.has(hostname.toLowerCase());
}

export function isPrimaryPublicDomain(hostname: string): boolean {
  return hostname.toLowerCase() === PRIMARY_DOMAIN;
}

export function getPrimaryDomainUrl(location: Location = window.location): string {
  return `https://${PRIMARY_DOMAIN}${location.pathname}${location.search}${location.hash}`;
}

async function clearLegacyDomainState(): Promise<void> {
  const tasks: Promise<unknown>[] = [];

  if ("serviceWorker" in navigator) {
    tasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister()))),
    );
  }

  if ("caches" in window) {
    tasks.push(
      window.caches
        .keys()
        .then((keys) => Promise.all(keys.filter((key) => key.startsWith("nm-")).map((key) => window.caches.delete(key)))),
    );
  }

  await Promise.allSettled(tasks);
}

export function redirectLegacyDomainToPrimary(): boolean {
  if (typeof window === "undefined") return false;
  if (!isLegacyPublicDomain(window.location.hostname)) return false;

  let redirected = false;
  const target = getPrimaryDomainUrl(window.location);
  const redirect = () => {
    if (redirected) return;
    redirected = true;
    window.location.replace(target);
  };

  void clearLegacyDomainState().finally(redirect);
  window.setTimeout(redirect, 600);
  return true;
}
